module.exports = __webpack_public_path__ + "media/images/app/products/necklaces_green_background-b2721d2910d89e48edd8cadff09e9adc.webp";